export default __webpack_public_path__ + "static/space-7-608db92baed9501119e6e91c0bb2f4fe.jpg";